import React, {
  FunctionComponent,
  SVGAttributes,
  useMemo,
  Suspense,
} from 'react'
import iconMap from './icon-map'
import { getTheme } from '@conexasaude/conexa-hero'
import { IconTypes } from './icon-types'

const EmptyIcon = () => <div />

interface PropsIcon extends Omit<SVGAttributes<HTMLElement>, 'color'> {
  name: IconTypes
  size?: string
  width?: string
  height?: string
  color?: string
  ariaLabel?: string
}

const Icon: FunctionComponent<PropsIcon> = ({
  name,
  size = '20px',
  width = '',
  height = '',
  color,
  ariaLabel,
  ...rest
}) => {
  const theme = getTheme()
  const Icon =
    iconMap?.icons?.[name] || iconMap?.illustrations?.[name] || EmptyIcon

  const style = useMemo(() => {
    const realSize: { width: string; height: string } = {
      width: 'unset',
      height: 'unset',
    }
    if (width || height) {
      if (width) realSize.width = width
      if (height) realSize.height = height
      return realSize
    }
    return { width: size, height: size }
  }, [height, size, width])

  return (
    <Suspense fallback={<i />}>
      <Icon
        css={{ color: color ?? theme.colors.brand.primary[300] }}
        style={style}
        color={color ?? theme.colors.brand.primary[300]}
        aria-label={ariaLabel}
        {...rest}
      />
    </Suspense>
  )
}

export default Icon
